'use strict';

/* Custom styles / vendor styles override */
import './styles/vendor/datepicker.custom.scss';
import './styles/vendor/jquery.minicolors.custom.css';
import './styles/vendor/prism.custom.css';

/* Core Components */
import Directives from './core/directives/directives.module';
import Filters from './core/filters/filters.module';
import Services from './core/services/services.module';

/* Modules */
import Modules from './modules';

/* Global Styles */
import './styles/styles.scss';

const DEFAULT_PHONE_COUNTRY = 'US';
const filterStateNames = [
  'signin',
  'signup',
  'password'
];

export default angular
  .module('app', [
    'ui.router',
    'ngSanitize',
    'ngResource',
    'ngCookies',
    'pascalprecht.translate',
    'minicolors',
    'flow',
    Directives,
    Filters,
    Services,
    Modules
  ])
  .run(($rootScope, $state, $location, $stateParams, utils, ToastsService, $log, BrandsService) => {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.errorMessages = {};
    $rootScope.version = VERSION;
    $rootScope.date = new Date();
    $rootScope.currentYear = $rootScope.date.getFullYear();
    $rootScope.host = window.location.hostname.split('.').slice(-2).join('.');
    $rootScope.currentBrand = BrandsService.getBrandConfig();

    $rootScope.$watchCollection('errorMessages', () => {
      if ($.isEmptyObject($rootScope.errorMessages)) {
        $rootScope.showErrorMessages = false;
      } else {
        // $rootScope.showErrorMessages = true;
        for (let key in $rootScope.errorMessages) {
          let message = $rootScope.errorMessages[key];
          ToastsService.error(null, message);
        }
        $rootScope.errorMessages = {}; // Clear error messages
      }
    });

    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
      $(window).off('resize');
      let flag = false;
      for (let i = 0; i < filterStateNames.length; i++) {
        if (filterStateNames[i] == toState.name) {
          flag = true;
          break;
        }
      }

      if (!flag) { // Check API_KEY
        let apiKey = utils.getApiKey();
        if (apiKey == null) {
          event.preventDefault();
          utils.clearCache();
          $state.go('signin', null, { reload: true });
        }
      }
    });

    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
      if (!$state.includes('main')) {
        $('body').removeClass('dimmable undetached pushable');
        $('#maestro-sidebar').remove();
        $('div.pusher').remove();
        $('div.ui.dimmer.modals.page').remove();
      }
      $rootScope.currentUrl = $location.url();
      $rootScope.$emit('refreshStateMenuEvent', toState);
    });

    $rootScope.$on('$stateChangeError', (event, toState, toParams, fromState, fromParams, error) => {
      $log.error(error);
    });

    /**
     * Custom phone validation rule
     * @param {string} value Field value
     * @param {number} [props] Country code and type
     * @returns {boolean}
     */
    $.fn.form.settings.rules.phoneValidation = (value, props) => {
      // FIXED_LINE_OR_MOBILE - types: 1 (Cell), 2 (Home), 3 (Work), 4 (Office)
      // MOBILE - types: 1
      // TOLL_FREE (8 800) - types: 2, 3, 4
      // FIXED_LINE - types: 2, 3, 4
      let properties = props && JSON.parse(props);
      if (!value || !properties || !properties.code) {
        return true;
      }
      let phone = '+' + properties.code + value;

      // console.log(phone);
      // console.log(properties);

      try {
        const phoneNumber = libphonenumber.parsePhoneNumberWithError(phone, DEFAULT_PHONE_COUNTRY);
        return phoneNumber.isPossible();
      } catch (error) {
        if (error instanceof libphonenumber.ParseError) {
          // INVALID_COUNTRY
          // NOT_A_NUMBER
          // TOO_LONG
          // TOO_SHORT
          // console.log(error.message);
          return false;
        }
        return false;
      }
    };
  })

  .config(($locationProvider, $stateProvider, $urlRouterProvider) => {

    $urlRouterProvider.otherwise(($injector, $location) => {
      let $rootScope = $injector.get('$rootScope');
      if ($rootScope.currentUrl && $rootScope.currentUrl != '/') {
        return $rootScope.currentUrl;
      } else {
        return '/main';
      }
    });
  });
